<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="add">新增</Button>
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row }" slot="name">
				<strong>{{ row.name }}</strong>
			</template>
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)">修改</Button>
				<Button type="primary" size="small" style="margin-right: 5px" @click="allotAisle(row)">分配货道</Button>
				
				
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				loading:false,
				total:100,
				columns12: [{
						title: 'id',
						key: 'id',
						width:80,
						align: 'center',
					},
					{
						title: '合同编号',
						key: 'contractCode',
						width:150,
						align: 'center',
					},
					{
						title: '供应商名称',
						key: 'operName',
						width:150,
						align: 'center',
					},
					{
						title: '金额',
						key: 'money',
						width:80,
						align: 'center',
						render: (h, params) => {
						    return h("div",params.row.money/100)
						}
					},
					{
						title: '录入人',
						key: 'empName',
						width:120,
						align: 'center',
					},
					{
						title: '货道数量',
						key: 'number',
						width:120,
						align: 'center',
					},
					{
						title: '已分配数量',
						key: 'allotNumber',
						width:150,
						align: 'center',
					},
					// {
					// 	title: '开始时间',
					// 	key: 'beginDateTime'
					// },
					// {
					// 	title: '结束时间',
					// 	key: 'overDateTime'
					// },
					{
						title: '录入时间',
						key: 'createdTime',
						width:150,
						align: 'center',
					},
					{
						title: '操作',
						slot: 'action',
						width: 300,
						align: 'center'
					}
				],
				data6: [
					{
						/* id: '1',
						name: '饮料',
						state: '启用',
						createdTime: '2010-10-10',
						cz: '' */
					}
				],
				query:{
					page:0,
					size:10
				},
				
			}
		},
		methods: {
			forbidden(id){
				this.deleteId=id
				this.modal2=true
			},
			allotAisle(row){
				this.$router.push({
					name: 'jm/platform/alliotMacAisle/macList',
					query:{
						orderId:row.id,
						operId:row.operId
					}
				})
			},
			update(id) { //修改
				this.$router.push({
					name: 'jm/platform/macAisleOrder/update',
					query:{
						id:id
					}
				})
			},
			add() {
				this.$router.push({
					name: 'jm/platform/macAisleOrder/add'
				})
			},
			
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/aisle/contract/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.page.totalElements
						_this.data6 = data.page.content
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
		},
	    components: {
	    	page
	    },
		created(){
			this.ajaxPage()
		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}
	.my-page{
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/macAisleOrder/list.vue